module.exports = __webpack_public_path__ + "img/technology3.18e2e88a.png";